module.exports = __webpack_public_path__ + "static/Especialistas_Neutrons_Pulsados-5e2850121208a57c86f67bb70521e861.jpg";